import React from 'react';

const Itinerario = (props) => {
  if (!props || props.itinerario === null) {
    return null;
  }

  return (
    <div className='seccion'>
      <h3 className='titulo-seccion'>Itinerario</h3>
      <div className='panel panel-default custom bordeado itinerario'>
        <div className='panel-body'>
          <div className='col-lg-12'>
            <div className='descripcion'>
              {props.itinerario}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Itinerario;
